import * as types from "./types";

export function fetchBackupPlansStart() {
  return {
    type: types.FETCH_BACKUP_PLANS_START
  };
}

export function fetchBackupPlansSuccess(data) {
  return {
    type: types.FETCH_BACKUP_PLANS_SUCCESS,
    data
  };
}

export function enableBackupPlanStart(data) {
  return {
    type: types.ENABLE_BACKUP_PLAN_START,
    data
  };
}
export function fetchBackupPlansSettingStart(backupPlanID) {
  return {
    type: types.FETCH_BACKUP_PLANS_SETTING_START,
    backupPlanID
  };
}

export function fetchBackupPlansSettingSuccess(data) {
  return {
    type: types.FETCH_BACKUP_PLANS_SETTING_SUCCESS,
    data
  };
}

export function enableBackupPlanSuccess(data) {
  return {
    type: types.ENABLE_BACKUP_PLAN_SUCCESS,
    data
  };
}
export function saveBackupPlansSettingStart(data) {
  return {
    type: types.SAVE_BACKUP_PLANS_SETTING_START,
    data
  };
}

export function disableBackupPlanStart(data) {
  return {
    type: types.DISABLE_BACKUP_PLAN_START,
    data
  };
}
export function saveBackupPlansSettingSuccess(data) {
  return {
    type: types.SAVE_BACKUP_PLANS_SETTING_SUCCESS,
    data
  };
}

export function disableBackupPlanSuccess(data) {
  return {
    type: types.DISABLE_BACKUP_PLAN_SUCCESS,
    data
  };
}

export function toggleBackupPlansCheckList(planId) {
  return {
    type: types.TOGGLE_BACKUP_PLANS_CHECKLIST,
    planId
  };
}

export function changeBackupPlansCheckList(data) {
  return {
    type: types.CHANGE_BACKUP_PLANS_CHECKLIST,
    data
  };
}

export function deleteBackupPlanStart(data) {
  return {
    type: types.DELETE_BACKUP_PLAN_START,
    data
  };
}

export function deleteBackupPlanSuccess(data) {
  return {
    type: types.DELETE_BACKUP_PLAN_SUCCESS,
    data
  };
}
export function cleanBackupPlanCache(key) {
  return {
    type: types.CLEAN_BACKUP_PLAN_CACHE,
    key
  };
}

export function setCleanBackupPlanCache(planId) {
  return {
    type: types.SET_CLEAN_BACKUP_PLAN_CACHE,
    planId
  };
}

export function createNewBackupPlanStart(data) {
  return {
    type: types.CREATE_NEW_BACKUP_PLAN_START,
    data
  };
}

export function createNewBackupPlanSuccess(data) {
  return {
    type: types.CREATE_NEW_BACKUP_PLAN_SUCCESS,
    data
  };
}

export function resetLoadingSettings() {
  return {
    type: types.RESET_LOADING_SETTINGS
  };
}

export function fetchDefaultPlanToCreatePlanStart() {
  return {
    type: types.FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_START
  };
}

export function fetchDefaultPlanToCreatePlanSuccess(data) {
  return {
    type: types.FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_SUCCESS,
    data
  };
}

export function saveBackupPlansSettingFailure() {
  return {
    type: types.SAVE_BACKUP_PLAN_SETTINGS_FAILURE
  };
}

export function backupPlansAPIDown(data) {
  return {
    type: types.BACKUP_PLANS_API_DOWN,
    data
  };
}

export function editDefaultPlan(data) {
  return {
    type: types.EDIT_DEFAULT_PLAN,
    data
  };
}
